import React from "react";

export default function KpiTile({ label, value, accent = "slate", icon: Icon }) {
  const cls =
    accent === "emerald"
      ? "text-emerald-700"
      : accent === "sky"
      ? "text-sky-700"
      : accent === "amber"
      ? "text-amber-700"
      : "text-slate-900";
  return (
    <div className="rounded-md border border-slate-200 bg-white p-3">
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
        {Icon ? <Icon className="h-3.5 w-3.5 text-slate-400" /> : null}
      </div>
      <div className={`text-2xl font-bold tabular-nums mt-0.5 ${cls}`}>{value}</div>
    </div>
  );
}
